<template>
  <div>
    <b-row>
      <b-col sm="6" class="form-group" v-if="!readonly">
        <form-write-group-label-input v-model="Name" isMandatory
          :inputLabel="$t('common.alerts.name')"
          :placeholderValue="$t('common.alerts.name')"
          autocomplete="off"
        >
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group" v-else>
        <form-read-group-label-input isMandatory
          :inputLabel="$t('common.alerts.name')"
          :inputValue="Name">
        </form-read-group-label-input>
      </b-col>

      <b-col sm="6" class="form-group" v-if="!readonly">
        <label for="metrickey">
          {{ $t('common.alerts.metrics_key') }}<span class="color-red"> * </span>
        </label>
        <select class="form-control" v-model="IdMetricsKey" id="metrickey" @change="updateThresholdUnitList" aria-required="true" autocomplete="off">
          <option :value="undefined" selected disabled>{{ $t('common.alerts.metrics_key_select') }}</option>
          <option v-for="metricsKey in metricsKeyList" :key="metricsKey.id" :value="metricsKey.id">
            {{ $t('common.monitoring.key.' + metricsKey.text) }}
          </option>
        </select>
      </b-col>
      <b-col sm="6" class="form-group" v-else>
        <form-read-group-label-input isMandatory
          :inputLabel="$t('common.alerts.metrics_key')"
          :inputValue="$t('common.monitoring.key.' + MetricsKey)">
        </form-read-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group" v-if="!readonly">
        <label for="thresholdUnit">
          {{ $t('common.alerts.threshold_unit') }}<span class="color-red"> * </span>
        </label>
        <select class="form-control" v-model="IdThresholdUnit" id="thresholdUnit" aria-required="true" autocomplete="off">
          <option :value="undefined" selected disabled>{{ $t('common.alerts.threshold_unit_select') }}</option>
          <option v-for="thresholdUnit in thresholdUnitList" :key="thresholdUnit.id" :value="thresholdUnit.id">
            {{ thresholdUnit.text }}
          </option>
        </select>
      </b-col>
      <b-col sm="6" class="form-group" v-else>
        <form-read-group-label-input isMandatory
          :inputLabel="$t('common.alerts.threshold_unit')"
          :inputValue="ThresholdUnit">
        </form-read-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group" v-if="!readonly">
        <form-write-group-label-input v-model="ThresholdLow" inputType="number" isMandatory
          :inputLabel="$t('common.alerts.threshold_low')"
          :placeholderValue="$t('common.alerts.threshold_low')"
          autocomplete="off"
        >
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group" v-else>
        <form-read-group-label-input isMandatory
          :inputLabel="$t('common.alerts.threshold_low')"
          :inputValue="ThresholdLow" inputType="number">
        </form-read-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group" v-if="!readonly">
        <form-write-group-label-input v-model="ThresholdHigh" inputType="number" isMandatory
          :inputLabel="$t('common.alerts.threshold_high')"
          :placeholderValue="$t('common.alerts.threshold_high')"
          autocomplete="off"
        >
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group" v-else>
        <form-read-group-label-input isMandatory
          :inputLabel="$t('common.alerts.threshold_high')"
          :inputValue="ThresholdHigh" inputType="number">
        </form-read-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group" v-if="readonly">
        <form-read-group-label-input isMandatory
          :inputLabel="$t('common.alerts.updated_at')"
          :inputValue="UpdatedAt">
        </form-read-group-label-input>
      </b-col>
      <!-- desactiver pour lot 1 -->
      <!-- <b-col cols="6" class="form-group" v-if="!readonly">
        <label>{{ $t('common.email.email_group') }}</label>

        <a id="emailGrp-picker-link" class="filter-item-content d-flex justify-content-between p-1 pt-2" href="#" style="max-width:calc(100% - 30px)">
          <span :class="'fixed-span-size ' + (selectedGroupNames.length > 0 ? 'filter-item-input-complete' : '')">
            <span v-for="(group, index) in selectedGroupNames" :key="group.id">
              {{ group.name }}<span v-if="index < selectedGroupNames.length - 1">, </span>
            </span>
            <span v-if="selectedGroupNames.length === 0">{{ $t('common.email.selected_grp_name_none') }}</span>
          </span>
          <i class="fa-light fa-chevron-down" size="17px" id="emailGrp-chevron"></i>
        </a>

        <b-popover target="emailGrp-picker-link"
          :title="$t('common.email.selected_group_name_none')"
          triggers="focus" placement="bottom">
          <span v-for="(groupEmail, index) in emailGroupList" :key="$t('common.email.group_name.' + groupEmail.id) + '-' + index">
            <b-form-checkbox v-model="groupEmail.state"
              :checked="groupEmail.state === groupEmail.id"
              @change="updateSelectedGroupNames"
              :value="groupEmail.id"
              :unchecked-value="0">
              <span>{{ groupEmail.text }}</span>
            </b-form-checkbox>
          </span>
        </b-popover>
      </b-col> -->
      <b-col sm="6" class="form-group" v-else-if="EmailGroupName > 0">
        <form-read-group-label-input
          :inputLabel="$t('common.email.group_name')"
          :inputValue="Array.isArray(EmailGroupName) ? EmailGroupName.join(', ') : EmailGroupName">
        </form-read-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group" v-if="!readonly">
        <form-write-group-label-input v-model="Description"
          :inputLabel="$t('common.alerts.description')"
          :placeholderValue="$t('common.alerts.description')"
          autocomplete="off"
        >
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group" v-else-if="Description">
        <form-read-group-label-input
          :inputLabel="$t('common.alerts.description')"
          :inputValue="Description">
        </form-read-group-label-input>
      </b-col>

      <b-col sm="6" class="form-group" v-if="!readonly">
        <label for="criticality">
          {{ $t('common.alerts.criticality_level') }}<span class="color-red"> * </span>
        </label>
        <select class="form-control" v-model="Criticality" id="criticality" aria-required="true" autocomplete="off">
          <option :value="undefined" selected disabled>{{ $t('common.alerts.criticality_level_select') }}</option>
          <option v-for="criticality in criticalityList" :key="criticality.id" :value="criticality.id">
            {{ criticality.label }}
          </option>
        </select>
      </b-col>
      <!-- <b-col sm="6" class="form-group" v-else>
        <form-read-group-label-input isMandatory
          :inputLabel="$t('common.alerts.criticality_level')"
          :inputValue="Criticality">
        </form-read-group-label-input>
      </b-col> -->
      <b-col sm="6" class="form-group" v-else>
        <form-read-group-label-input
          isMandatory
          :inputLabel="$t('common.alerts.criticality_level')"
          :inputValue="getCriticalityLabel(Criticality)">
        </form-read-group-label-input>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import formWriteGroupLabelInput from "@/components/common/formWriteGroupLabelInput.vue"
import {errorMessageAlert} from '@/helpers/alert'
import moment from 'moment-timezone'

export default {
  name: "AlertsForm",
  components: {
    'form-read-group-label-input': formReadGroupLabelInput,
    "form-write-group-label-input": formWriteGroupLabelInput
  },
  props: {
    mode: {
      type: String,
      default: "add"
    },
    readonly: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    // selectedGroupNames() {
    //   return this.emailGroupList
    //     .filter(groupEmail => groupEmail.state === groupEmail.id)
    //     .map(groupEmail => groupEmail.text)
    //     .join(', ')
    // },
    inputValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    Name: {
      get () {
        return this.inputValue.Name
      },
      set (val) {
        this.inputValue = {
          Name: val,
          MetricsKey: this.inputValue.MetricsKey,
          ThresholdHigh: this.inputValue.ThresholdHigh,
          ThresholdLow: this.inputValue.ThresholdLow,
          ThresholdUnit: this.inputValue.ThresholdUnit,
          UpdatedAt: this.inputValue.UpdatedAt,
          EmailGroupName: this.inputValue.EmailGroupName,
          IdEmailGroupName: this.inputValue.IdEmailGroupName,
          IdMetricsKey: this.inputValue.IdMetricsKey,
          IdThresholdUnit: this.inputValue.IdThresholdUnit,
          Description: this.inputValue.Description === '$NotFound' ? '' : this.inputValue.Description,
          selectedGroupNames: this.inputValue.selectedGroupNames,
          Criticality: this.inputValue.Criticality
        }
      }
    },
    MetricsKey: {
      get () {
        return this.inputValue.MetricsKey
      },
      set (val) {
        this.inputValue = {
          Name: this.inputValue.Name,
          MetricsKey: val,
          ThresholdHigh: this.inputValue.ThresholdHigh,
          ThresholdLow: this.inputValue.ThresholdLow,
          ThresholdUnit: this.inputValue.ThresholdUnit,
          UpdatedAt: this.inputValue.UpdatedAt,
          EmailGroupName: this.inputValue.EmailGroupName,
          IdEmailGroupName: this.inputValue.IdEmailGroupName,
          IdMetricsKey: this.inputValue.IdMetricsKey,
          IdThresholdUnit: this.inputValue.IdThresholdUnit,
          Description: this.inputValue.Description === '$NotFound' ? '' : this.inputValue.Description,
          selectedGroupNames: this.inputValue.selectedGroupNames,
          Criticality: this.inputValue.Criticality
        }
      }
    },
    ThresholdHigh: {
      get () {
        return this.inputValue.ThresholdHigh
      },
      set (val) {
        this.inputValue = {
          Name: this.inputValue.Name,
          MetricsKey: this.inputValue.MetricsKey,
          ThresholdHigh: val,
          ThresholdLow: this.inputValue.ThresholdLow,
          ThresholdUnit: this.inputValue.ThresholdUnit,
          UpdatedAt: this.inputValue.UpdatedAt,
          EmailGroupName: this.inputValue.EmailGroupName,
          IdEmailGroupName: this.inputValue.IdEmailGroupName,
          IdMetricsKey: this.inputValue.IdMetricsKey,
          IdThresholdUnit: this.inputValue.IdThresholdUnit,
          Description: this.inputValue.Description === '$NotFound' ? '' : this.inputValue.Description,
          selectedGroupNames: this.inputValue.selectedGroupNames,
          Criticality: this.inputValue.Criticality
        }
      }
    },
    ThresholdLow: {
      get () {
        return this.inputValue.ThresholdLow
      },
      set (val) {
        this.inputValue = {
          Name: this.inputValue.Name,
          MetricsKey: this.inputValue.MetricsKey,
          ThresholdHigh: this.inputValue.ThresholdHigh,
          ThresholdLow: val,
          ThresholdUnit: this.inputValue.ThresholdUnit,
          UpdatedAt: this.inputValue.UpdatedAt,
          EmailGroupName: this.inputValue.EmailGroupName,
          IdEmailGroupName: this.inputValue.IdEmailGroupName,
          IdMetricsKey: this.inputValue.IdMetricsKey,
          IdThresholdUnit: this.inputValue.IdThresholdUnit,
          Description: this.inputValue.Description === '$NotFound' ? '' : this.inputValue.Description,
          selectedGroupNames: this.inputValue.selectedGroupNames,
          Criticality: this.inputValue.Criticality
        }
      }
    },
    ThresholdUnit: {
      get () {
        return this.inputValue.ThresholdUnit
      },
      set (val) {
        this.inputValue = {
          Name: this.inputValue.Name,
          MetricsKey: this.inputValue.MetricsKey,
          ThresholdHigh: this.inputValue.ThresholdHigh,
          ThresholdLow: this.inputValue.ThresholdLow,
          ThresholdUnit: val,
          UpdatedAt: this.inputValue.UpdatedAt,
          EmailGroupName: this.inputValue.EmailGroupName,
          IdEmailGroupName: this.inputValue.IdEmailGroupName,
          IdMetricsKey: this.inputValue.IdMetricsKey,
          IdThresholdUnit: this.inputValue.IdThresholdUnit,
          Description: this.inputValue.Description === '$NotFound' ? '' : this.inputValue.Description,
          selectedGroupNames: this.inputValue.selectedGroupNames,
          Criticality: this.inputValue.Criticality
        }
      }
    },
    UpdatedAt: {
      get () {
        return this.getDate(this.inputValue.UpdatedAt)
      },
      set (val) {
        this.inputValue = {
          Name: this.inputValue.Name,
          MetricsKey: this.inputValue.MetricsKey,
          ThresholdHigh: this.inputValue.ThresholdHigh,
          ThresholdLow: this.inputValue.ThresholdLow,
          ThresholdUnit: this.inputValue.ThresholdUnit,
          UpdatedAt: val,
          EmailGroupName: this.inputValue.EmailGroupName,
          IdEmailGroupName: this.inputValue.IdEmailGroupName,
          IdMetricsKey: this.inputValue.IdMetricsKey,
          IdThresholdUnit: this.inputValue.IdThresholdUnit,
          Description: this.inputValue.Description === '$NotFound' ? '' : this.inputValue.Description,
          selectedGroupNames: this.inputValue.selectedGroupNames,
          Criticality: this.inputValue.Criticality
        }
      }
    },
    EmailGroupName: {
      get () {
        if (typeof this.inputValue.EmailGroupName === 'string') {
          return this.inputValue.EmailGroupName.split(',').map(item => item.trim())
        }
        return this.inputValue.EmailGroupName || []
      },
      set (val) {
        this.inputValue = {
          Name: this.inputValue.Name,
          MetricsKey: this.inputValue.MetricsKey,
          ThresholdHigh: this.inputValue.ThresholdHigh,
          ThresholdLow: this.inputValue.ThresholdLow,
          ThresholdUnit: this.inputValue.ThresholdUnit,
          UpdatedAt: this.inputValue.UpdatedAt,
          EmailGroupName: val,
          IdEmailGroupName: this.inputValue.IdEmailGroupName,
          IdMetricsKey: this.inputValue.IdMetricsKey,
          IdThresholdUnit: this.inputValue.IdThresholdUnit,
          Description: this.inputValue.Description === '$NotFound' ? '' : this.inputValue.Description,
          selectedGroupNames: this.inputValue.selectedGroupNames,
          Criticality: this.inputValue.Criticality
        }
      }
    },
    IdEmailGroupName: {
      get () {
        if (typeof this.inputValue.IdEmailGroupName === 'string') {
          return this.inputValue.IdEmailGroupName.split(',').map(item => item.trim())
        }
        return this.inputValue.IdEmailGroupName || []
      },
      set (val) {
        this.inputValue = {
          Name: this.inputValue.Name,
          MetricsKey: this.inputValue.MetricsKey,
          ThresholdHigh: this.inputValue.ThresholdHigh,
          ThresholdLow: this.inputValue.ThresholdLow,
          ThresholdUnit: this.inputValue.ThresholdUnit,
          UpdatedAt: this.inputValue.UpdatedAt,
          EmailGroupName: this.inputValue.EmailGroupName,
          IdEmailGroupName: val.filter(Boolean).join(', '),
          IdMetricsKey: this.inputValue.IdMetricsKey,
          IdThresholdUnit: this.inputValue.IdThresholdUnit,
          Description: this.inputValue.Description === '$NotFound' ? '' : this.inputValue.Description,
          selectedGroupNames: this.inputValue.selectedGroupNames,
          Criticality: this.inputValue.Criticality
        }
      }
    },
    IdMetricsKey: {
      get () {
        return this.inputValue.IdMetricsKey
      },
      set (val) {
        this.inputValue = {
          Name: this.inputValue.Name,
          MetricsKey: this.inputValue.MetricsKey,
          ThresholdHigh: this.inputValue.ThresholdHigh,
          ThresholdLow: this.inputValue.ThresholdLow,
          ThresholdUnit: this.inputValue.ThresholdUnit,
          UpdatedAt: this.inputValue.UpdatedAt,
          EmailGroupName: this.inputValue.EmailGroupName,
          IdEmailGroupName: this.inputValue.IdEmailGroupName,
          IdMetricsKey: val,
          IdThresholdUnit: this.inputValue.IdThresholdUnit,
          Description: this.inputValue.Description === '$NotFound' ? '' : this.inputValue.Description,
          selectedGroupNames: this.inputValue.selectedGroupNames,
          Criticality: this.inputValue.Criticality
        }
      }
    },
    IdThresholdUnit: {
      get () {
        return this.inputValue.IdThresholdUnit
      },
      set (val) {
        this.inputValue = {
          Name: this.inputValue.Name,
          MetricsKey: this.inputValue.MetricsKey,
          ThresholdHigh: this.inputValue.ThresholdHigh,
          ThresholdLow: this.inputValue.ThresholdLow,
          ThresholdUnit: this.inputValue.ThresholdUnit,
          UpdatedAt: this.inputValue.UpdatedAt,
          EmailGroupName: this.inputValue.EmailGroupName,
          IdEmailGroupName: this.inputValue.IdEmailGroupName,
          IdMetricsKey: this.inputValue.IdMetricsKey,
          IdThresholdUnit: val,
          Description: this.inputValue.Description === '$NotFound' ? '' : this.inputValue.Description,
          selectedGroupNames: this.inputValue.selectedGroupNames,
          Criticality: this.inputValue.Criticality
        }
      }
    },
    Description: {
      get () {
        return this.inputValue.Description === '$NotFound' ? '' : this.inputValue.Description
      },
      set (val) {
        this.inputValue = {
          Name: this.inputValue.Name,
          MetricsKey: this.inputValue.MetricsKey,
          ThresholdHigh: this.inputValue.ThresholdHigh,
          ThresholdLow: this.inputValue.ThresholdLow,
          ThresholdUnit: this.inputValue.ThresholdUnit,
          UpdatedAt: this.inputValue.UpdatedAt,
          EmailGroupName: this.inputValue.EmailGroupName,
          IdEmailGroupName: this.inputValue.IdEmailGroupName,
          IdMetricsKey: this.inputValue.IdMetricsKey,
          IdThresholdUnit: this.inputValue.IdThresholdUnit,
          Description: val,
          selectedGroupNames: this.inputValue.selectedGroupNames,
          Criticality: this.inputValue.Criticality
        }
      }
    },
    selectedGroupNames: {
      get () {
        const ids = this.inputValue.IdEmailGroupName
          ? this.inputValue.IdEmailGroupName.split(',').map(id => id.trim())
          : []
        const names = this.inputValue.EmailGroupName
          ? this.inputValue.EmailGroupName.split(',').map(name => name.trim())
          : []

        const existingGroups = ids.map((id, index) => ({
          id: id,
          name: names[index] || '',
          state: ids.includes(id) ? id : 0
        }))

        const dynamicGroups = this.emailGroupList
          .filter(groupEmail => groupEmail.state === groupEmail.id)
          .map(groupEmail => ({
            id: groupEmail.id,
            name: groupEmail.text,
            state: groupEmail.state === groupEmail.id ? groupEmail.id : 0
          }))

        let selectedGroupDetails = []

        if (dynamicGroups.length === 0) {
          selectedGroupDetails = existingGroups
        } else {
          selectedGroupDetails = dynamicGroups
        }

        // const selectedGroupDetails = [...existingGroups, ...dynamicGroups]
        //   .filter((group, index, self) =>
        //     index === self.findIndex((g) => g.id === group.id)
        //   )

        this.emailGroupList.forEach(group => {
          const isSelected = selectedGroupDetails.some(selected => selected.id === group.id)
          group.state = isSelected ? group.id : 0
        })

        this.inputValue.selectedGroupNames = selectedGroupDetails

        return this.inputValue.selectedGroupNames
      },
      set (val) {
        this.inputValue = {
          Name: this.inputValue.Name,
          MetricsKey: this.inputValue.MetricsKey,
          ThresholdHigh: this.inputValue.ThresholdHigh,
          ThresholdLow: this.inputValue.ThresholdLow,
          ThresholdUnit: this.inputValue.ThresholdUnit,
          UpdatedAt: this.inputValue.UpdatedAt,
          EmailGroupName: this.inputValue.EmailGroupName,
          IdEmailGroupName: this.inputValue.IdEmailGroupName,
          IdMetricsKey: this.inputValue.IdMetricsKey,
          IdThresholdUnit: this.inputValue.IdThresholdUnit,
          Description: this.inputValue.Description === '$NotFound' ? '' : this.inputValue.Description,
          selectedGroupNames: val,
          Criticality: this.inputValue.Criticality
        }

        const ids = val.map(group => group.state !== 0 ? group.id : '').filter(id => id).join(',')
        const names = val.map(group => group.state !== 0 ? group.name : '').filter(name => name).join(',')
        this.inputValue.IdEmailGroupName = ids
        this.inputValue.EmailGroupName = names

        this.updateEmailGroupStates(val)
      }
    },
    Criticality: {
      get () {
        return this.inputValue.Criticality
      },
      set (val) {
        this.inputValue = {
          Name: this.inputValue.Name,
          MetricsKey: this.inputValue.MetricsKey,
          ThresholdHigh: this.inputValue.ThresholdHigh,
          ThresholdLow: this.inputValue.ThresholdLow,
          ThresholdUnit: this.inputValue.ThresholdUnit,
          UpdatedAt: this.inputValue.UpdatedAt,
          EmailGroupName: this.inputValue.EmailGroupName,
          IdEmailGroupName: this.inputValue.IdEmailGroupName,
          IdMetricsKey: this.inputValue.IdMetricsKey,
          IdThresholdUnit: this.inputValue.IdThresholdUnit,
          Description: this.inputValue.Description === '$NotFound' ? '' : this.inputValue.Description,
          selectedGroupNames: this.inputValue.selectedGroupNames,
          Criticality: val
        }
      }
    },
  },
  data() {
    return {
      elementSearchedEmailGroup: '',
      elementSearchedMetricsKey: '',
      elementSearchedThresholdUnit: '',
      metricsKeyList: [],
      thresholdUnitList: [],
      emailGroupList: [],
      criticalityList: {
        LOW: {
          label: this.$t('common.alerts.low'),
          id: 0
        },
        MEDIUM: {
          label: this.$t('common.alerts.medium'),
          id: 1
        },
        HIGH: {
          label: this.$t('common.alerts.high'),
          id: 2
        },
        CRITICAL: {
          label: this.$t('common.alerts.critical'),
          id: 3
        }
      },
      criticalityMapping: {
        0: 'LOW',
        1: 'MEDIUM',
        2: 'HIGH',
        3: 'CRITICAL'
      },
      timezone: '+00:00'
    }
  },
  created() {
    this.timezone = moment.tz.guess()
    // desactiver pour lot 1
    // this.getEmailGroups()
    this.getMetricsKey()
    this.getThresholdUnit()
  },
  watch: {
    IdMetricsKey (newVal, oldVal) {
      if (newVal) {
        this.inputValue.IdThresholdUnit = undefined
        this.updateThresholdUnitList()
      }
    }
  },
  methods: {
    getCriticalityLabel(criticalityKey) {
      return this.criticalityList[this.criticalityMapping[criticalityKey]]?.label || ''
    },
    getDate (date) {
      if (!date || date == ''){
        return '-'
      }
      const hasTimezone = /([+-]\d{2}:\d{2}|Z)$/.test(date);
      const isoWithTZ = hasTimezone ? date : date + 'Z';
      return moment(isoWithTZ).tz(this.timezone).format('DD/MM/YYYY HH:mm:ss');
    },
    getEmailGroups () {
      let params = { name: this.elementSearchedEmailGroup }
      let that = this
      this.$engine.firstOn().email.emailGroup.fetch(params).then((resp) => {
        this.emailGroupList = resp.data.EmailGroup.map(group => ({
          id: group.IdEmailGroup,
          text: group.GroupName,
          value: group.GroupName,
          state: 0
        }))
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getMetricsKey () {
      let params = { name: this.elementSearchedMetricsKey }
      let that = this
      this.$engine.firstOn().monitoring.metricsKey.fetch(params).then((resp) => {
        const uniqueMetricsKey = new Set()
        this.metricsKeyList = resp.data.MetricsKey.filter((metricsKey) => {
          const isUnique = !uniqueMetricsKey.has(metricsKey.IdMetricsKey)
          uniqueMetricsKey.add(metricsKey.IdMetricsKey)
          return isUnique
        }).map((metricsKey) => ({
          id: metricsKey.IdMetricsKey,
          text: metricsKey.MetricsKey,
          value: metricsKey.MetricsKey,
          idMetricsUnit: metricsKey.IdMetricsUnit,
          metricsUnit: metricsKey.MetricsUnit
        })).sort((a, b) => a.text.localeCompare(b.text))

        this.updateThresholdUnitList()
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getThresholdUnit () {
      let params = { name: this.elementSearchedThresholdUnit }
      let that = this
      this.$engine.firstOn().monitoring.metricsUnit.fetch(params).then((resp) => {
        const uniqueMetricsUnit = new Set()
        this.thresholdUnitList = resp.data.MetricsUnit.filter((metricsUnit) => {
          const isUnique = !uniqueMetricsUnit.has(metricsUnit.IdMetricsUnit)
          uniqueMetricsUnit.add(metricsUnit.IdMetricsUnit)
          return isUnique
        }).map((metricsUnit) => ({
          id: metricsUnit.IdMetricsUnit,
          text: metricsUnit.MetricsUnit,
          value: metricsUnit.MetricsUnit,
          idMetricsKey: metricsUnit.IdMetricsKey,
          metricsKey: metricsUnit.MetricsKey
        }))

        this.allThresholdUnits = resp.data.MetricsUnit.map((metricsUnit) => ({
          id: metricsUnit.IdMetricsUnit,
          text: metricsUnit.MetricsUnit,
          value: metricsUnit.MetricsUnit,
          idMetricsKey: metricsUnit.IdMetricsKey,
          metricsKey: metricsUnit.MetricsKey
        }))

      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    updateEmailGroupStates (groups) {
      this.emailGroupList.forEach(group => {
        const isSelected = groups.some(selected => selected.id === group.id)
        group.state = isSelected ? group.id : 0
      })
    },
    updateSelectedGroupNames () {
      const selectedGroups = this.emailGroupList
        .filter(group => group.state === group.id)
        .map(group => ({
          id: group.id,
          name: group.text,
          state: group.state,
        }))

      this.selectedGroupNames = selectedGroups
    },
    updateThresholdUnitList () {
      if (this.IdMetricsKey) {
        if (this.allThresholdUnits){
          this.thresholdUnitList = this.allThresholdUnits.filter(unit => {
            return unit.idMetricsKey === this.IdMetricsKey
          })
        }
      } else {
        this.thresholdUnitList = []
      }
    },
  }
}
</script>
